//For Nodemailer See: https://dev.to/jlong4223/how-to-implement-email-functionality-with-node-js-react-js-nodemailer-and-oauth2-2h7m
//For Recaptcha See: https://blog.logrocketnpm install --save react-google-recaptcha.com/implement-recaptcha-react-application/

import React, { useState, useRef, Suspense } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import kontaktStyle from "../styles/Kontakt.module.scss";
import {useTranslation} from "react-i18next";

// cf. https://www.tutorialspoint.com/regex-in-reactjs
//const validEmail = new RegExp ('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$')
const validName = new RegExp ('^[a-zA-Z0-9À-ÖØ-öø-ſ\s]$')

function HeaderComponent()
{
  let readyToSend = true;
  const [t, i18n] = useTranslation('translation');
    
  const [mailerState, setMailerState] = useState({
    salutation: "",
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    ref: t('contact.mail.ref'),
    greeting: "",
    sub_our: t('contact.mail.sub_our'),
    sub_visitor: t('contact.mail.sub_visitor'),
    intro_our: t('contact.mail.intro_our'),
    intro_visitor: t('contact.mail.intro_visitor'),
    phone_key: t('contact.mail.phone_key'),
    sub_key: t('contact.mail.sub_key'),
    mes_key: t('contact.mail.mes_key'),
    closing: t('contact.mail.closing')
  });

  const captchaRef = useRef(null);

  function handleStateChange(e) {
    e.persist();
    setMailerState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
}

  // see: https://stackoverflow.com/a/41297611/7601437
  function checkForm(mailerState) {
    if (mailerState.email.trim() === "") {
      alert("Bitte Email Adresse eingeben");
      readyToSend = false;
    }
    if (mailerState.email !== "undefined") {
      let lastAtPos = mailerState.email.lastIndexOf("@");
      let lastDotPos = mailerState.email.lastIndexOf(".");

      if (!(
        lastAtPos < lastDotPos &&
        lastAtPos > 0 &&
        mailerState.email.indexOf("@@") === -1 &&
        lastDotPos > 2 &&
        mailerState.email.length - lastDotPos > 2
      )) {
        readyToSend = false;
        alert("Es liegt ein Fehler bei der Email Adresse vor");
      }
    }

    if (mailerState.name.trim() === "") {
      alert("Bitte Name eingeben");
      readyToSend = false;
    }
    //TODO: Throwing error!
    if (mailerState.name !== "undefined") {
      if(validName.test(mailerState.name)) {
        readyToSend = false;
        alert("Es gibt ein unzulässiges Zeichen im Namen");
      }
     /*  if (mailerState.name.match(/^[-'a-zA-ZÀ-ÖØ-öø-ſ]+$/)) {
        readyToSend = false;
        alert("Es gibt ein unzulässiges Zeichen im Namen");
      } */
    }
    if (mailerState.message.trim() === "") {
      alert("Bitte fügen Sie eine Nachricht hinzu");
      readyToSend = false;
    }
  }

  function getGreeting() {
    let greeting= "";
    if(i18n.language === "en"){
      greeting = "Dear"
    } else {
      switch(mailerState.salutation) {
        case t('contact.form.mr'):
          greeting = "Sehr geehrter";
          break;
        case t('contact.form.ms'):
          greeting = "Sehr geehrte";
          break;
        default:
          greeting = "Hallo";
      }
    }
    mailerState.greeting = greeting;
  }

  const submitEmail = async (e) => {
    e.preventDefault();

    checkForm(mailerState);

    if (readyToSend) {
      //handling captcha
      const token = captchaRef.current.getValue();
      captchaRef.current.reset();
      getGreeting();

      await axios.post(process.env.REACT_APP_API_POST, { token })
        .then(res => console.log({ mailerState }),

          await fetch(process.env.REACT_APP_API_SEND, {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify({ mailerState }),
          })
            .then((res) => res.json())
            .then(async (res) => {
              const resData = await res;
              if (resData.status === "success") {
                alert("Message Sent");
              } else if (resData.status === "fail") {
                alert("Message failed to send");
              }
            })
            .then(() => {
              setMailerState({
                salutation: "",
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
                ref: t('contact.mail.ref'),
                greeting: "",
                sub_our: t('contact.mail.sub_our'),
                sub_visitor: t('contact.mail.sub_visitor'),
                intro_our: t('contact.mail.intro_our'),
                intro_visitor: t('contact.mail.intro_visitor'),
                phone_key: t('contact.mail.phone'),
                sub_key: t('contact.mail.sub_key'),
                mes_key: t('contact.mail.mes_key'),
                closing: t('contact.mail.closing')
              });
            })
        )
        .catch((error) => {
          console.log(error);
        });
    }
  };
	return <div id="wrapper">
    <main>
      <div id="formWrap">
        <h2>{t('contact.form.h2')}</h2>
        <h4>{t('contact.form.h4')}</h4>
        <div id={kontaktStyle.form}>
          <form onSubmit={submitEmail}>
            <select name="salutation" id="salutation" onChange={handleStateChange} value={mailerState.salutation}>
              <option value="select" defaultValue>{t('contact.form.sal')}</option>
              <option value={t('contact.form.mr')}>{t('contact.form.mr')}</option>
              <option value={t('contact.form.ms')}>{t('contact.form.ms')}</option>
              <option value="blank">–</option>
            </select>

            <input placeholder="Name" onChange={handleStateChange} name="name" value={mailerState.name} />
            <span id="name_error"></span>

            <input placeholder="Email" onChange={handleStateChange} name="email" value={mailerState.email} />
            <span id="email_error"></span>

            <input placeholder="Telefon" onChange={handleStateChange} name="phone" value={mailerState.phone} />

            <select name="subject" id="subject" onChange={handleStateChange} value={mailerState.subject}>
              <option value="Kein Betreff" defaultValue>{t('contact.form.sub')}</option>
              <option value="Anfrage für Notensatz">{t('contact.form.sub_ns')}</option>
              <option value="Anfrage für Textbearbeitung">{t('contact.form.sub_te')}</option>
              <option value="Sonstige Anfrage">{t('contact.form.sub_other')}</option>
            </select>

            <textarea placeholder="Message" onChange={handleStateChange} name="message" value={mailerState.message} />
            <span id="message_error"></span>

            <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} className={kontaktStyle.padded} />

            <button>{t('contact.form.send')}</button>

            <div className={kontaktStyle.padded}>{t('contact.form.copy')}</div>
          </form>
        </div>
      </div>
    </main>
    <aside>
      <p>Nikolaus Veeser<br />Freiberuflicher Notengrafiker</p>
      <p>Basler Str. 41<br />79227 Schallstadt</p>
      <p>Tel.: <a href="tel:+497664617807">+49 7664 617807</a><br />Fax: +49 7664 617959<br />Mail: <a href="mailto:info@notensatz.com">Info {'{'}ät{'}'} Notensatz.com</a></p>
      <p className={kontaktStyle.map}>
        <iframe title="GoogleMap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2671.868061124836!2d7.761080315749774!3d47.958275379209574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4791053fc97dbd05%3A0x22ad8b58a39187b4!2sBasler%20Str.%2041%2C%2079227%20Schallstadt!5e0!3m2!1sen!2sde!4v1571040709863!5m2!1sen!2sde"></iframe>
      </p>
    </aside>
  </div>
}

function Kontakt() {
  return (
    <Suspense fallback="loading">
	<div className="App">
		<HeaderComponent/>
	</div>
</Suspense>
  );
}

export default Kontakt